import { Box, Stack, Divider } from '@mui/material';
import Skeleton from "@mui/material/Skeleton";
import Card from "@vapor/react-material/Card";
import CardContent from "@vapor/react-material/CardContent";

export const LoadingSkeleton = () => {
    return (
        <Box sx={{ ml: 2, mr: 2, mt: 3 }}>
            {/* Skeleton per il titolo del gruppo */}
            <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
                <Skeleton variant="text" width={400} height={40} />
            </Box>

            {/* Skeleton per le card dei duplicati */}
            <Box sx={{ maxHeight: '650px', overflowY: 'auto', pr: 1 }}>
                <Stack direction="column" spacing={2} sx={{ mb: 3 }}>
                    {[...Array(2)].map((_, idx) => (
                        <Card key={idx} sx={{ border: '1px solid #ccc' }}>
                            <CardContent>
                                {/* Header card */}
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                                    <Skeleton variant="text" width={150} height={30} />
                                    <Skeleton variant="rectangular" width={180} height={40} />
                                </Box>
                                <Divider sx={{ mb: 2 }} />
                                
                                {/* Contenuto a due colonne */}
                                <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2 }}>
                                    {/* Colonna sinistra */}
                                    <Box sx={{ flex: 1 }}>
                                        <Stack direction="column" spacing={1}>
                                            <Skeleton variant="text" width="90%" height={20} />
                                            <Skeleton variant="text" width="85%" height={20} />
                                            <Skeleton variant="text" width="80%" height={20} />
                                            <Skeleton variant="text" width="75%" height={20} />
                                            <Divider sx={{ my: 2 }} />
                                            <Skeleton variant="text" width="90%" height={20} />
                                            <Skeleton variant="text" width="85%" height={20} />
                                            <Skeleton variant="text" width="80%" height={20} />
                                            <Skeleton variant="text" width="75%" height={20} />
                                        </Stack>
                                    </Box>
                                    
                                    <Divider orientation="vertical" flexItem />
                                    
                                    {/* Colonna destra */}
                                    <Box sx={{ flex: 1 }}>
                                        <Stack direction="column" spacing={1}>
                                            <Skeleton variant="text" width="90%" height={20} />
                                            <Skeleton variant="text" width="85%" height={20} />
                                            <Skeleton variant="text" width="80%" height={20} />
                                            <Divider sx={{ my: 2 }} />
                                            <Skeleton variant="text" width="75%" height={20} />
                                            <Skeleton variant="text" width="70%" height={20} />
                                            <Skeleton variant="text" width="65%" height={20} />
                                        </Stack>
                                    </Box>
                                </Box>
                            </CardContent>
                        </Card>
                    ))}
                </Stack>
            </Box>

            {/* Skeleton per la navigazione */}
            <Box sx={{ mt: 4 }}>
                <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                    <Skeleton variant="text" width={200} height={30} />
                </Box>
                <Stack direction="row" spacing={2} justifyContent="center" alignItems="center">
                    <Skeleton variant="circular" width={48} height={48} />
                    <Skeleton variant="rectangular" width={400} height={8} sx={{ borderRadius: '4px' }} />
                    <Skeleton variant="circular" width={48} height={48} />
                </Stack>
            </Box>
        </Box>
    );
};
